import React from 'react';
import styled from 'styled-components';
import Icon from './icons';
import { socialMedia } from '../config/index';
const SocialMobileContainer = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`;
const StyledLink = styled.a`
  text-decoration: none;
  margin: 10px 20px 0 20px;
  svg {
    width: 20px;
    height: 20px;
    fill: var(--color-text);
  }
  &:hover,
  &:focus {
    svg {
      fill: var(--color-primary);
    }
  }
`;
const SocialMobile = () => {
  return (
    <SocialMobileContainer>
      {socialMedia &&
        socialMedia.map((social, idx) => (
          <StyledLink target="_blank" key={idx} href={social.url} rel="noreferrer">
            <Icon iconName={social.iconName} />
          </StyledLink>
        ))}
    </SocialMobileContainer>
  );
};
export default SocialMobile;
